import { failure } from '$lib/stores/Toast';
import { translations } from '$lib/translations/i18n';

export class SPBError {
    private message: string;
    private status: number;
    
    private static getErrorMessage(key: string): string {
        try {
            return translations().SPBError[key] ?? 'Operazione Fallita';
        } catch (error) {
            return 'Operazione Fallita';
        }
    }

    constructor(message: string, status: number = 500) {
        this.message = SPBError.getErrorMessage(message);
        this.status = status;
    }

    show() {
        failure(this.message);
    }
}
